export interface RadioProps {
  uiId: string;
  checked: boolean;
  onChange: (next: boolean) => void;
  label?: string;
  disabled?: boolean;
  /** 同一組 radio 必須共用同一個 name，否則瀏覽器不會互斥。 */
  name?: string;
  /** 送出值（批次 14：report 查詢 radio 的 legacy value 代碼；未給＝瀏覽器預設 on）。 */
  value?: string;
}

/**
 * 單選鈕。
 *
 * ponytail: 同 Checkbox，用原生 `<input type="radio">` ＋ accent-color，不還原 iCheck 的
 * `.iradio_square-green` sprite（custom.css:34-49）。【雛形值待實機校準】
 *
 * 刻意不做 RadioGroup：互斥是瀏覽器靠 name 屬性做的，再包一層只是把原生行為抄一遍。
 * 呼叫端需要一組時就 map 出多個 Radio 並給同一個 name。
 */
export function Radio({ uiId, checked, onChange, label, disabled = false, name, value }: RadioProps) {
  const input = (
    <input
      type="radio"
      id={uiId}
      data-ui-id={uiId}
      name={name}
      {...(value === undefined ? {} : { value })}
      className="size-[22px] shrink-0 accent-brand disabled:cursor-not-allowed"
      checked={checked}
      disabled={disabled}
      onChange={(event) => onChange(event.target.checked)}
    />
  );

  if (label === undefined) {
    return input;
  }

  return (
    <label htmlFor={uiId} className="inline-flex cursor-pointer items-center gap-2 text-ink">
      {input}
      <span>{label}</span>
    </label>
  );
}
